import { toast } from 'sonner';

// Lydvarsel KUN for lag-meldinger med play_sound (f.eks. «flyttet opp til Lag 1»)
const KEY = 'team_sound_played_ids';

const chime = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    [[880, 0], [1175, 0.18], [1568, 0.36]].forEach(([f, t]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = 'sine';
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.35);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.4);
    });
    if (navigator.vibrate) navigator.vibrate([120, 60, 120]);
  } catch { /* lyd er ikke kritisk */ }
};

export const playTeamSound = (messages) => {
  const played = new Set(JSON.parse(localStorage.getItem(KEY) || '[]'));
  const fresh = messages.filter(m => m.play_sound && !played.has(m.id));
  if (!fresh.length) return;
  fresh.forEach(m => played.add(m.id));
  localStorage.setItem(KEY, JSON.stringify([...played].slice(-100)));
  chime();
  toast.success(fresh[0].subject, { description: 'Se Meldinger for detaljer', duration: 8000 });
};
